import React, { useState } from 'react';
import { getAuthToken, setAuthToken, clearAuthToken } from './lib/api-client';
import { AddPlaylist } from './pages/AddPlaylist';
import { PlaylistList } from './pages/PlaylistList';
import './App.css';

function App() {
  const [token, setToken] = useState(getAuthToken() || '');
  const [authenticated, setAuthenticated] = useState(!!getAuthToken());
  const [page, setPage] = useState<'auth' | 'add' | 'list'>('add');

  const handleSetToken = (newToken: string) => {
    setAuthToken(newToken);
    setToken(newToken);
    setAuthenticated(true);
  };

  const handleLogout = () => {
    setToken('');
    setAuthenticated(false);
    clearAuthToken();
  };

  if (!authenticated) {
    return (
      <div className="app auth-page">
        <h1>IPTV App</h1>
        <p>Enter your authentication token:</p>
        <input
          type="password"
          value={token}
          onChange={(e) => setToken(e.target.value)}
          placeholder="Bearer token"
        />
        <button onClick={() => handleSetToken(token)}>Login</button>
      </div>
    );
  }

  return (
    <div className="app">
      <header>
        <h1>IPTV App</h1>
        <nav>
          <button
            className={page === 'add' ? 'active' : ''}
            onClick={() => setPage('add')}
          >
            Add Playlist
          </button>
          <button
            className={page === 'list' ? 'active' : ''}
            onClick={() => setPage('list')}
          >
            My Playlists
          </button>
          <button onClick={handleLogout}>Logout</button>
        </nav>
      </header>

      <main>
        {page === 'add' && <AddPlaylist />}
        {page === 'list' && <PlaylistList />}
      </main>
    </div>
  );
}

export default App;
